import React from 'react';
import { useField } from 'informed';
import { FormGroup, InputGroup } from '@blueprintjs/core';
export const TextInput = (props) => {
    const { ref, fieldApi, fieldState, userProps } = useField({ ...props });
    const { setValue } = fieldApi;
    const { value, error } = fieldState;
    const { placeholder, helperText, label, labelInfo, inline } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(FormGroup, { helperText: helperText, label: label, labelFor: props.field, labelInfo: labelInfo, intent: error ? 'danger' : 'success', inline: inline },
            React.createElement(InputGroup, { id: props.field, placeholder: placeholder, defaultValue: value, contentEditable: true, intent: error ? 'danger' : 'none', onChange: (e) => setValue(e.target.value) }))));
};
//# sourceMappingURL=TextInput.js.map